import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { FaChartPie, FaUser } from 'react-icons/fa6';
import { DistributionMode } from '../../types';
import '../../../../../../styles/Forms.scss';
import './DistributionModeModal.scss';

interface DistributionModeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (mode: DistributionMode) => void;
}

const DistributionModeModal: React.FC<DistributionModeModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [selectedMode, setSelectedMode] = useState<DistributionMode>('percentage');

  const handleConfirm = () => {
    onConfirm(selectedMode);
    setSelectedMode('percentage');
  };

  const handleClose = () => {
    setSelectedMode('percentage');
    onClose();
  };

  return (
    <Modal
      show={isOpen}
      onHide={handleClose}
      centered
      dialogClassName="distribution-mode-modal-dialog"
    >
      <Modal.Header>
        <div className="form-modal-title-container">
          <Modal.Title className="form-modal-title">Método de Distribución</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={handleClose}>
          <X size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body className="distribution-mode-body">
        <p className="body-subtitle">
          Selecciona cómo deseas distribuir las propinas
        </p>

        <div className="mode-options">
          <div
            className={`mode-option ${selectedMode === 'percentage' ? 'selected' : ''}`}
            onClick={() => setSelectedMode('percentage')}
          >
            <div className="mode-radio">
              <div className={`radio-circle ${selectedMode === 'percentage' ? 'active' : ''}`}>
                {selectedMode === 'percentage' && <div className="radio-dot" />}
              </div>
            </div>
            <div className="mode-content">
              <div className="mode-header">
                <span className="mode-icon"><FaChartPie /></span>
                <h3>Distribución por Porcentaje</h3>
                <span className="mode-badge default">Por defecto</span>
              </div>
              <p className="mode-description">
                El total de propinas se reparte entre todos los empleados según un porcentaje de participación 
                configurable, independiente de cuánto contribuyó cada uno al pool.
              </p>
              <div className="mode-example">
                <span className="example-label">Ejemplo:</span> Si hay $100.000 en propinas y 3 empleados con 100%, 
                cada uno recibe $33.333.
              </div>
            </div>
          </div>

          <div
            className={`mode-option ${selectedMode === 'individual' ? 'selected' : ''}`}
            onClick={() => setSelectedMode('individual')}
          >
            <div className="mode-radio">
              <div className={`radio-circle ${selectedMode === 'individual' ? 'active' : ''}`}>
                {selectedMode === 'individual' && <div className="radio-dot" />}
              </div>
            </div>
            <div className="mode-content">
              <div className="mode-header">
                <span className="mode-icon"><FaUser /></span>
                <h3>Distribución por Contribución Individual</h3>
              </div>
              <p className="mode-description">
                Cada mesero recibe exactamente las propinas que generó según su participación 
                en la toma de pedidos. El sistema atribuye las propinas al mesero que atendió cada mesa.
              </p>
              <div className="mode-example">
                <span className="example-label">Ejemplo:</span> Si Juan atendió la mesa 3 y la propina fue $10.000, 
                Juan recibe los $10.000 completos.
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button variant="none" className="form-button-cancel" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="none" className="form-button-create" onClick={handleConfirm}>
            Continuar
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DistributionModeModal;
